const CarfoRentRouter = [
  {
      path: "list-car_for_rent",
      name: "list",
      component: () => import("@/views/admin/car_for_rent"),
      default: true,
      meta: {
          model: "car_for_rent",
          // requiresAuth: true,
      },
  },
  {
      path: "list-car_for_rent/add",
      name: "add",
      component: () => import("@/views/admin/car_for_rent/function"),
      default: true,
      meta: {
          model: "car_for_rent",
          // requiresAuth: true,
      },
  },
  {
      path: "list-car_for_rent/edit/:id",
      name: "edit",
      component: () => import("@/views/admin/car_for_rent/function"),
      default: true,
      meta: {
          model: "car_for_rent",
          // requiresAuth: true,
      },
  },
];
export default CarfoRentRouter;